import { z } from 'zod'

import { Date } from '@/modules/shared/schemas/Date'
import { DateTime } from '@/modules/shared/schemas/DateTime'

import { FoodStockFoodItemCondition } from './FoodStockFoodItemCondition'
import { FoodStockFoodItemStatus } from './FoodStockFoodItemStatus'

export const FoodStockFoodItem = z.object({
  id: z.string(),
  quantity: z.number(),
  validityAfterOpening: z.number(),
  expirationDate: Date,
  expirationDateAfterOpening: Date.nullable(),
  dataOpening: Date.nullable(),
  condition: FoodStockFoodItemCondition,
  status: FoodStockFoodItemStatus,
  createdAt: DateTime,
  code: z.string()
})
export type FoodStockFoodItem = z.infer<typeof FoodStockFoodItem>

export const FoodStockFoodItemList = FoodStockFoodItem.array()
export type FoodStockFoodItemList = z.infer<typeof FoodStockFoodItemList>

export const CreateFoodStockFoodItemDTO = z.object({
  quantity: z.number(),
  validityAfterOpening: z.number(),
  expirationDate: Date,
  condition: FoodStockFoodItemCondition,
  code: z.string().optional()
})
export type CreateFoodStockFoodItemDTO = z.infer<
  typeof CreateFoodStockFoodItemDTO
>

export const CreateFoodStockFoodItemInFoodStockDTO =
  CreateFoodStockFoodItemDTO.extend({
    stockFoodId: z.string()
  })
export type CreateFoodStockFoodItemInFoodStockDTO = z.infer<
  typeof CreateFoodStockFoodItemInFoodStockDTO
>
